/**
 * @generated SignedSource<<fb69e0bf037f25d8a86d12833cc76b18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
export type CreateWidgetWeatherInput = {
  lat?: number | null;
  lng?: number | null;
  placeId?: string | null;
  positionX: number;
  positionY: number;
  size: WidgetWeatherSize;
  title?: string | null;
};
export type WAWeatherMutation$variables = {
  input: CreateWidgetWeatherInput;
  storecastId: string;
};
export type WAWeatherMutation$data = {
  readonly dashboard: {
    readonly createWidgetWeather: {
      readonly id: string;
    };
  };
};
export type WAWeatherMutation = {
  response: WAWeatherMutation$data;
  variables: WAWeatherMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetWeather",
        "kind": "LinkedField",
        "name": "createWidgetWeather",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAWeatherMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAWeatherMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bdbbd61887bf13161dbfa530647221e2",
    "id": null,
    "metadata": {},
    "name": "WAWeatherMutation",
    "operationKind": "mutation",
    "text": "mutation WAWeatherMutation(\n  $storecastId: ID!\n  $input: CreateWidgetWeatherInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetWeather(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "162dd0265aafbaca7a62a6755da05510";

export default node;
